module.exports = __webpack_public_path__ + "media/heroes/welcome-bg-130e6da5.jpg";